<template>
  <div class="upload-image">
    <input
      type="file"
      @change="handleFileSelect"
      @drop.prevent="handleFileDrop"
      @dragover.prevent
      ref="fileInput"
      style="display: none"
    />
    <div @click="triggerFileSelect" class="upload-image__button">
      <div class="upload-image__preview">
        <img v-if="previewUrl" :src="previewUrl" alt="Preview" />
      </div>
      <div class="upload-image__btn">
        Upload an image
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    defaultPreviewUrl: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      previewUrl: this.defaultPreviewUrl,
      file: null
    };
  },
  methods: {
    triggerFileSelect() {
      this.$refs.fileInput.click();
    },
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        this.setFile(file);
      }
    },
    handleFileDrop(event) {
      const file = event.dataTransfer.files[0];
      if (file) {
        this.setFile(file);
      }
    },
    setFile(file) {
      this.file = file;
      this.previewUrl = URL.createObjectURL(file);
      this.$emit('file-selected', this.file);
    }
  }
};
</script>
